import * as Types from '@/types/global';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NavigationQueryVariables = Types.Exact<{
  data: Types.NavigationInput;
}>;

export type NavigationQuery = {
  navigation: Array<{
    __typename: 'Navigation';
    id: number;
    label: string;
    icon: string | null;
    items: Array<{
      __typename: 'NavigationUIItem';
      id: number;
      label: string;
      href: string | null;
      icon: string | null;
    }>;
  }>;
};

export const NavigationDocument = gql`
  query Navigation($data: NavigationInput!) {
    navigation(data: $data) {
      id
      label
      icon
      items {
        id
        label
        href
        icon
      }
    }
  }
`;

/**
 * __useNavigationQuery__
 *
 * To run a query within a React component, call `useNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigationQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useNavigationQuery(
  baseOptions: Apollo.QueryHookOptions<NavigationQuery, NavigationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NavigationQuery, NavigationQueryVariables>(NavigationDocument, options);
}
export function useNavigationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NavigationQuery, NavigationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<NavigationQuery, NavigationQueryVariables>(
    NavigationDocument,
    options,
  );
}
export type NavigationQueryHookResult = ReturnType<typeof useNavigationQuery>;
export type NavigationLazyQueryHookResult = ReturnType<typeof useNavigationLazyQuery>;
export type NavigationQueryResult = Apollo.QueryResult<NavigationQuery, NavigationQueryVariables>;
